import * as Yup from 'yup';

export const NonLegalBuyerAmlValidationSchema = Yup.object({
  politicallyExposed: Yup
    .string()
    .oneOf(['true', 'false', ''], 'Il valore deve essere "true", "false" o vuoto')
    .required('Il campo "Persona politicamente esposta" è obbligatorio')
    .test(
      'not-empty',
      'Il campo "Persona politicamente esposta" è obbligatorio',
      (value) => value !== '',
    ),
  relatedToAPoliticallyExposedFigure: Yup
    .string()
    .oneOf(['true', 'false', ''], 'Il valore deve essere "true", "false" o vuoto')
    .required('Il campo "Parente o convivente di persona politicamente esposta" è obbligatorio')
    .test(
      'not-empty',
      'Il campo "Parente o convivente di persona politicamente esposta" è obbligatorio',
      (value) => value !== '',
    ),
  mortgageMoneySource: Yup.boolean(),
  personalMoneySource: Yup.boolean(),
  sellingPersonalPropertiesMoneySource: Yup.boolean(),
  otherMoneySource: Yup.boolean(),
  otherMoneySourceValue: Yup
    .string()
    .when('otherMoneySource', {
      is: true,
      then: (schema) => schema
        .required('Specificare i dettagli relativi alla sorgente "Altro"')
        .test(
          'not-empty',
          'Specificare i dettagli relativi alla sorgente "Altro"',
          (value) => value !== undefined && value.trim().length > 0,
        ),
      otherwise: (schema) => schema.test(
        'should-be-empty',
        'Rimuovere i dettagli se la sorgente "Altro" non è selezionata',
        (value) => !value || value.trim().length === 0,
      ),
    }),
  notes: Yup.string(),
}).test(
  'at-least-one-money-source',
  (values, ctx) => {
    const isValid = values.mortgageMoneySource
      || values.personalMoneySource
      || values.sellingPersonalPropertiesMoneySource
      || values.otherMoneySource;

    if (isValid) return true;
    const errorFields = [
      'mortgageMoneySource',
      'personalMoneySource',
      'sellingPersonalPropertiesMoneySource',
      'otherMoneySource',
    ];
    const errors = errorFields.map((field) => ctx.createError({
      path: field,
      message: 'Selezionare almeno una sorgente del denaro',
    }));
    return new Yup.ValidationError(errors, values, ctx.path);
  },
);
